import * as Styled from './BulletedListItem.styled';
import type { BulletedListItemProps } from './BulletedListItem.typed';
import React from 'react';

export const BulletedListItem = (props: BulletedListItemProps) => {
  const { children, fontSize = 'M16' } = props;
  return <Styled.ListItem $fontSize={fontSize}>{children}</Styled.ListItem>;
};
